import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BaseButton } from '@repo/common';

const photoImg = `${process.env.REACT_APP_ASSETS_URL}/JobBoard/jobboard_banner_photo_dark.png`;
const arrowImg = `${process.env.REACT_APP_ASSETS_URL}/JobBoard/jobboard_banner_arrow_dark.svg`;

const DetailSidebarBlackBanner = () => {
  const navigate = useNavigate();

  return (
    <div className='flex w-full tabletV:max-w-[274px] flex-col items-start gap-4 overflow-hidden rounded-[8px] border-[1.6px] border-grayscale-gray02 bg-grayscale-gray10 p-4'>
      <div className='h-[160px] w-full shrink-0'>
        <img alt='' className='block size-full max-w-none' src={photoImg} />
      </div>

      <div className='flex w-full flex-col items-start gap-3'>
        <p className='w-full text-[38px] font-semibold leading-none tracking-[-1.14px] text-green-light02'>
          PATHFINDER
        </p>

        <p className='typo-b14Strong w-full'>
          <span className='text-grayscale-gray00'>Career gap</span>
          <span className='text-grayscale-gray04'> diagnosis </span>
          <br />
          <span className='text-grayscale-gray04'>and </span>
          <span className='text-grayscale-gray00'>skill support</span>
        </p>

        <BaseButton
          type='text'
          size='m'
          typo={false}
          isStatic
          leftalign
          onClick={() => navigate('/community/kpathport/pathfeed')}
          icon={
            <img alt='' className='h-[30px] w-[50px] shrink-0' src={arrowImg} />
          }
          iconPosition='after'
          gap='gap-2'
          className='group h-auto w-full min-w-0 cursor-pointer rounded-none border-0 bg-transparent p-0 [&>span]:items-end [&>span]:justify-end'
          textWrapperClass='typo-b14Strong h-auto min-w-0 flex-1 text-left text-grayscale-gray00 group-hover:underline'
        >
          Explore more
        </BaseButton>
      </div>
    </div>
  );
};

export default DetailSidebarBlackBanner;
